export default {
  SET_FUNDS_DATA(state, value) {
    state.availableFunds = value;
  },
  SET_USER_TRANSACTION(state, value) {
    state.transactions = value;
  },
  SET_TRANSACTION_HISTORY(state, value) {
    state.transactionHistory = value;
  },
  UPDATE_TRANSACTION_HISTORY(state, value) {
    state.transactionHistory.unshift(value);
  },
  SET_CURRENT_PLAN(state, plan) {
    state.currentPlan = plan;
  },
}
